// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  summarize: null,
  summarize_lotto: null,
  summarize_customer: null
}

const affiliateCustomer = (state = initialState, action) => {
  switch (action.type) {
    case 'AFFILIATE_SUMMARIZE':
      return {
        ...state,
        summarize: action.data
      }
    case 'AFFILIATE_SUMMARIZE_LOTTO':
      return {
        ...state,
        summarize_lotto: action.data
      }
    case 'AFFILIATE_SUMMARIZE_CUSTOMER':
      return {
        ...state,
        summarize_customer: action.data
      }

    default:
      return { ...state }
  }
}

export { affiliateCustomer }
